<template>
  <div class="card card-detail-layout mt-3">
    <div class="card-body py-5 text-center">     
      <p class="text-sm text-secondary">
        No hay actividad para el periodo seleccionado
      </p>
    </div>
  </div>
</template>
